import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HomeContent from './components/HomeContent';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <HomeContent />
      <Footer />
    </>
  );
}